// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__26gix","content":"styles_content__rJUjG","selectAll":"styles_selectAll__2kXbQ"};